import React from "react";
import { NotImplemented } from "pages/PayRoll/Shared/NotImplemented";

// Placeholder until Payroll Adjustments is built. Reached from
// Payroll > Pay Inputs > Payroll Adjustments in the sidebar flyout.
export const PayInputPayrollAdjustments = () => <NotImplemented title="Payroll Adjustments" />;
